module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    staticClass: "fake-loader"
  }, 'div', _vm.$props, false), [_c('span', {
    staticStyle: {
      "vertical-align": "top"
    },
    style: ({
      width: _vm.width,
      height: _vm.height
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f61738","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/Uloc/FakeLoader.vue
// module id = 1659
// module chunks = 17